import { FC, useContext } from 'react';

import { MainContext } from '../../providers/MainProvider';

import { IPage } from './interfaces';

import './styles.scss';

// page
const Page: FC<IPage> = ({
  title,
  data
}) => {
  const { onLoadPage } = useContext(MainContext);

  // render
  return (
    <div className="page">
      {title && 
        <h2 className='h2'>{title}</h2>
      }
      
      {onLoadPage(data)}
    </div>
  );
};

export default Page;